var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icona_stella",
    "data-name": "icona stella",
    transform: "translate(-963 -37)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icona_stella-2",
    "data-name": "icona stella",
    d: "M17.952,7.014a.955.955,0,0,0-.823-.657l-5.2-.472L9.88,1.077a.957.957,0,0,0-1.76,0L6.066,5.885l-5.2.472A.958.958,0,0,0,.326,8.031l3.928,3.444L3.1,16.576A.957.957,0,0,0,4.519,17.61L9,14.931l4.48,2.679A.957.957,0,0,0,14.9,16.576l-1.158-5.1,3.928-3.444a.958.958,0,0,0,.279-1.017ZM9.086,14.879",
    transform: "translate(963 36.504)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Rettangolo_774",
    "data-name": "Rettangolo 774",
    transform: "translate(963 37)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1,
    opacity: 0
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17,
    height: 17,
    fill: "none"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b3986b00bfeade816e4e9d3ca7ef119a.svg";
export { ForwardRef as ReactComponent };